import BaseComponent from "../BaseComponent";
import './BreadCrumbs.css';
import PropTypes from "prop-types";
import Button from "../../../appl/view/components/buttons/Button";
import StepLabel from "@mui/material/StepLabel";
import Step from "@mui/material/Step";

class BreadCrumb extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      active: (this.props.active !== undefined ? this.props.active : false)
    }
  }

  setIsActive(active) {
    this.state.active = active;
  }

  onClick(e) {
    this.props.onClick(e);
  }

  render() {

    return <Step key={this.props.key}>
      <StepLabel>{this.props.children}</StepLabel>
    </Step>
  }
}

BreadCrumb.propTypes = {
  onClick: PropTypes.func, active: PropTypes.bool
}
export default BreadCrumb;
